import request from "../../../../utils/api";

const customers = `customers`
const transactions = `transactions`

export const getCustomerTransaction = params => request(`${customers}/${params.id}/transactions`, { params });
export const updateCustomerTransaction = body => request(`${transactions}/${body.transaction.id}`, { method: 'put', body });

